import {useSelector} from 'react-redux';

function useGetTokenAndUser() {
  const token = useSelector((state: any) => state.authentication.user.token);
  const user = useSelector((state: any) => state.authentication.user.name);
  return {token, user};
}

export default useGetTokenAndUser;
